import {
  IonButtons,
  IonContent,
  IonHeader,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToast,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router";
import "../../components/ExploreContainer.css";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import axios from "axios";
import { requestID, baseUrl, config } from "../../common/utils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useBusinessContext } from "../../context/business-context";
import LedgerSubHead from "../../components/ledger/ledger-subheading-modal";
import styles from "../Business/GenerateInviteCode.module.css";
import { motion } from "framer-motion";
import LedgerSubHeadModal from "../../components/ledger/ledger-subheading-modal";

const CreateLedgerBranch_update = () => {
  const { selectedBusinessId, selectedBusinessName } = useBusinessContext();

  const schema = yup
    .object({
      ledgerName: yup.string().required("Please Enter Ledger Name"),
      ledgerType: yup.string().required("Please select ledger type"),
      branchID: yup.string().required("Please select a branch"),
      tbhLedger: yup.string().required("Please select a Trail balance heading"),
    })
    .required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { name } = useParams<{ name: string }>();

  const [ledgetType, setLedgetType] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [ledgerMother, setLedgerMother] = useState([]);
  const [ledgerMother2, setLedgerMother2] = useState([]);
  const [motherComp, setMotherComp] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [ratingRange, setRatingRange] = useState("0");
  const [message, setMessage] = useState("");
  const [showme, setShowme] = useState(true);

  const [ledgerName, setLedgerName] = useState("");
  const [branchID, setBranchID] = useState("");
  const [ledgerType, setLedgerType] = useState("");
  const [tbhLedger, setTbhLedger] = useState("");
  const [plhLedger, setPlhLedger] = useState("");
  const [bshLedger, setBshLedger] = React.useState("");
  const [tradingLedger, setTradingLedger] = React.useState("");
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const [checkTeller, setcheckTeller] = useState<Boolean>(false);

  const checkTellerx = () => {
    checkTeller ? setcheckTeller(false) : setcheckTeller(true);

    console.log(checkTeller);
  };

  const history = useHistory();
  const callToast = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 5000);
  };

  const getLedgers = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    //formData.append("business_id", selectedBusinessId);
    setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgercreates/getLedgerMothers_byBranch", formData, config)
      .then((response) => {
        console.log({ response });
        setLedgetType(response.data.ledgerType);
        setBranchList(response.data.branchList);
        setLedgerMother(response.data.data);
        setLedgerMother2(response.data.getLedgerMothers2);
        setMotherComp(response.data.getMotherComp);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  const getBranches = async () => {
    // try {
    setStatus({ loading: true, error: false });

    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("business_id", selectedBusinessId);

    console.log(formData);

    const response = await axios.post(
      baseUrl() + "businesss/getBranchList2",
      formData,
      config
    );
    console.log({ response });
    const data = await response.data.data;
    console.log({ data });
    setBranchList(data[2]);
    setStatus({ loading: false, error: false });
    // } catch (error) {
    console.error();
    //   setAlertMsg(error.response.data.message);
    // onShowAlert();
    // }
  };

  const addLedger = () => {
    setStatus({ loading: true, error: false });
    const formData = new FormData();

    formData.append("requestID", requestID());
    formData.append("ledgerName", ledgerName);
    formData.append("business_id", selectedBusinessId);
    formData.append("branch_id", branchID);
    formData.append("ledgerType", ledgerType);
    formData.append("tbhLedger", tbhLedger);
    formData.append("plhLedger", plhLedger);
    formData.append("tdaLedger", tradingLedger);
    formData.append("bshLedger", bshLedger);
    formData.append("checkTeller", checkTeller.toString());

    axios
      .post(baseUrl() + "ledgercreates/addLedger", formData, config)
      .then((response) => {
        console.log(response);

        console.log(response.data.status);

        setStatus({ loading: false, error: true });

        response.data.status === "false"
          ? setErrorLogin("Failed!")
          : setErrorLogin("Ledger Added Successfully !");
        setLedgerName("");
        setLedgerType("");
        setBranchID("");
        setBshLedger("");
        setTradingLedger("");

        // callToast();
        response.data.status === "false"
          ? ""
          : history.push("/folder/manageLedger/Manage Ledger");
      })
      .catch((error) => {
        setStatus({ loading: false, error: true });
        callToast();
        // throw new error("hey ");
      });
  };

  useIonViewWillEnter(() => {
    getLedgers();
    // getBranches()
    // fetchShopsById();
  }, []);

  return (
    <IonPage className="pushDown">
      <IonHeader>
        <Box display="flex" justifyContent="space-between" p={2}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
              {/* <Business className={styles.titleIcon} /> */}
              {selectedBusinessName?.toUpperCase()} - CREATE LEDGER
            </Typography>
          </motion.div>

          <Box>
            <Button
              onClick={() => setIsModalOpen(true)}
              variant="contained"
              color="success"
              slot="end"
            >
              Add Ledger Comp and Sub
            </Button>

            <Button
              variant="outlined"
              color="secondary"
              onClick={() => history.goBack()}
              style={{ marginLeft: 10 }}
            >
              Go Back
            </Button>
          </Box>
        </Box>
      </IonHeader>

      <IonContent fullscreen>
    
        <Box
          sx={{
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <Divider orientation="horizontal" flexItem />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            {/* <InputLabel id="demo-simple-select-label">Ledger Name</InputLabel> */}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Ledger Name"
              error={!!errors.ledgerName}
              {...register("ledgerName")}
              helperText={errors.ledgerName?.message}
              value={ledgerName}
              onChange={(event) => {
                setLedgerName(event.target.value);
              }}
            />
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Ledger Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              error={!!errors.ledgerType}
              {...register("ledgerType")}
              value={ledgerType}
              label="Ledger Type"
              onChange={(event) => {
                setLedgerType(event.target.value);
              }}
            >
              {ledgetType?.map((ledgetType) => {
                return (
                  <MenuItem key={ledgetType.id} value={ledgetType.catID}>
                    {ledgetType.name}
                  </MenuItem>
                );
              })}
            </Select>
            <Typography color={"red"} component={"h6"}>
              {errors.ledgerType?.message}
            </Typography>
          </FormControl>

          {/* <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Branch:
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              error={!!errors.branchID}
              {...register("branchID")}
              value={branchID}
              label="Ledger Type"
              onChange={(event) => {
                setBranchID(event.target.value);
              }}
            >
              {branchList?.map((branchList, i) => {
                return (
                  <MenuItem key={i} value={branchList.branch_id}>
                    {branchList.name}
                  </MenuItem>
                );
              })}
            </Select>
            <Typography color={"red"} component={"h6"}>
              {errors.branchID?.message}
            </Typography>
          </FormControl> */}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Ledger Trial Balance Sub-Heading
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              error={!!errors.tbhLedger}
              {...register("tbhLedger")}
              value={tbhLedger}
              label="Ledger Trial Balance Sub-Heading"
              onChange={(event) => {
                setTbhLedger(event.target.value);
              }}
            >
              {ledgerMother
                ?.filter((ledgerMother) => ledgerMother.motherID == 1)
                ?.map((ledgerMother, i) => {
                  return (
                    <MenuItem
                      key={i}
                      value={
                        ledgerMother.motherID + ":" + ledgerMother.subCompID
                      }
                    >
                      {ledgerMother.name}
                    </MenuItem>
                  );
                })}
            </Select>
            <Typography color={"red"} component={"h6"}>
              {errors.tbhLedger?.message}
            </Typography>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Ledger Profit and Loss Sub-Heading
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={plhLedger}
              label="Ledger Profit and Loss Sub-Heading"
              onChange={(event) => {
                setPlhLedger(event.target.value);
              }}
            >
              <MenuItem value=""> Please select a ledger</MenuItem>

              {ledgerMother
                ?.filter((ledgerMother) => ledgerMother.motherID == 5)
                ?.map((ledgerMother) => {
                  return (
                    <MenuItem
                      key={ledgerMother.id}
                      value={
                        ledgerMother.motherID + ":" + ledgerMother.subCompID
                      }
                    >
                      {ledgerMother.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Ledger trading account Sub-Heading
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={tradingLedger}
              label="Ledger Balance Sheet Sub-Heading"
              onChange={(event) => {
                setTradingLedger(event.target.value);
              }}

              /* onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
             //setBshLedger(event.target.value as string);
            }}*/
            >
              <MenuItem value=""> Please select a ledger</MenuItem>

              {ledgerMother
                ?.filter((ledgerMother) => ledgerMother.motherID == 7)
                ?.map((ledgerMother) => {
                  return (
                    <MenuItem
                      key={ledgerMother.id}
                      value={
                        ledgerMother.motherID + ":" + ledgerMother.subCompID
                      }
                    >
                      {ledgerMother.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Ledger Balance Sheet Sub-Heading
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={bshLedger}
              label="Ledger Balance Sheet Sub-Heading"
              onChange={(event) => {
                setBshLedger(event.target.value);
              }}

              /* onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
             //setBshLedger(event.target.value as string);
            }}*/
            >
              <MenuItem value=""> Please select a ledger</MenuItem>
              {ledgerMother
                ?.filter((ledgerMother) => ledgerMother.motherID == 3)
                ?.map((ledgerMother) => {
                  return (
                    <MenuItem
                      key={ledgerMother.id}
                      value={
                        ledgerMother.motherID + ":" + ledgerMother.subCompID
                      }
                    >
                      {ledgerMother.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ m: 1 }}>
          <Typography color={"red"} component={"h6"}>
            {bshLedger.length == 0 &&
              tradingLedger.length == 0 &&
              plhLedger.length == 0 &&
              " please select at least one ledger"}
          </Typography>
          {/* <Typography color={"red"} component={"h6"}>
            {[
              bshLedger.length > 0,
              tradingLedger.length > 0,
              plhLedger.length > 0,
            ].filter(Boolean).length > 1 &&
              "You can only select one ledger from (Trading | Balance Sheet | Profit & Loss)"}
          </Typography> */}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={checkTeller}
                onClick={checkTellerx}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Tick if creating a teller"
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",

            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <Button variant="contained" onClick={(addLedger)}>
            Submit
          </Button>
        </Box>

        <LedgerSubHeadModal
          ledgerMothersType={ledgerMother2}
          isOpen={isModalOpen}
          branchList={branchList}
          getMotherComp={motherComp}
          onClose={() => setIsModalOpen(false)}
          getMotherLedgers={() => getLedgers()}
        />

        <IonLoading
          message="Logging..."
          spinner="circles"
          isOpen={status.loading}
        />
        {status.error && (
          <IonToast position="middle" isOpen={showToast} message={errorLogin} />
        )}
      </IonContent>
    </IonPage>
  );
};

export default CreateLedgerBranch_update;
